"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var defaultTheme = function defaultTheme(theme) {
  return {
    appearance: {
      primary: {
        background: theme.color.primary1["default"],
        color: theme.color.monochrome1["default"]
      },
      secondary: {
        background: theme.color.monochrome1["default"],
        color: theme.color.primary1["default"]
      }
    }
  };
};

var _default = defaultTheme;
exports["default"] = _default;
//# sourceMappingURL=NumberBadge.theme.js.map